// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 549 ? "dayjs-locale-fr" : chunkId) + "." + {"247":"2d7d9d0a","297":"0352140e","442":"ed772577","499":"1b4bd760","549":"c6312040","787":"85665653","896":"a2e522ee"}[chunkId] + ".chunk.js";
};